import { formatAppDisplayName } from "./branding.logic";

const APP_BASE_NAME = "HeyDex";
const APP_STAGE_LABEL = import.meta.env.DEV ? "Dev" : "Latest";
export const APP_DISPLAY_NAME = formatAppDisplayName({
  baseName: APP_BASE_NAME,
  stageLabel: APP_STAGE_LABEL,
});
export const APP_VERSION = import.meta.env.APP_VERSION || "0.0.0";
